import { render, staticRenderFns } from "./personalExam.vue?vue&type=template&id=76668fe2&scoped=true&"
import script from "./personalExam.vue?vue&type=script&lang=js&"
export * from "./personalExam.vue?vue&type=script&lang=js&"
import style0 from "./personalExam.vue?vue&type=style&index=0&id=76668fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76668fe2",
  null
  
)

export default component.exports